{
    "coordinates": [
        30.63594369292629,
        104.89501790713285
    ],
    "tooltip": "Jialingjiang",
    "title": "Jialingjiang Formation",
    "country": "China",
    "period": "Triassic",
    "alt": "TODO"
}
